import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { ORDERDETAILS } from "npmlinks-constants";

const {
  ORDER_DETAILS: { STORE_PICK },
} = ORDERDETAILS;

class StoreAddressText extends PureComponent {
  get selectedAddress() {
    const { value } = this.props;
    if (!value) {
      return "";
    }
    const {
      fcName = "",
      state = "",
      streetName = "",
      streetNo = "",
      town = "",
    } = value;
    return !fcName ? "" : `${fcName}, ${streetNo}, ${streetName}, ${town}`;
  }

  get isAddressContent() {
    const address = this.selectedAddress;
    return !address || address === ""
      ? ""
      : "nw-storeaddselectedAddressselectedAddressresstext-content";
  }

  get addressTitle() {
    const { title } = this.props;
    return this.selectedAddress ? title || STORE_PICK : "";
  }

  get mobileNumber() {
    const { value } = this.props;
    if (!value) {
      return "";
    }
    return value.contactNo ? `${value.contactNo}` : "";
  }

  render() {
    const { className, isMobile, value, showTitle } = this.props;
    return (
      <div className={`${className} nw-storeaddresstext-wrap`}>
        {showTitle && this.addressTitle && (
          <div className="nw-consignment-subtitle nw-consignment-address">
            {this.addressTitle}
          </div>
        )}
        <address
          className={`nw-storeaddresstext-address ${this.isAddressContent}`}
        >
          {this.selectedAddress}
          {isMobile && value.contactNo ? (
            <div className="nw-storeaddresstext-mobile">
              Ph: {this.mobileNumber}
            </div>
          ) : null}
        </address>
      </div>
    );
  }
}

StoreAddressText.defaultProps = {
  value: {},
  isMobile: true,
  className: "",
  showTitle: false,
  title: "",
};

StoreAddressText.propTypes = {
  value: PropTypes.shape({}),
  isMobile: PropTypes.bool,
  showTitle: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: StoreAddressText,
  component: StoreAddressText,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/StoreAddressText/index.js